<template>
  <div class="c-app flex-row align-items-center login">
   
    <CContainer>
      <CRow class="justify-content-center">
         
        <CCol md="8">
          <CAlert
            color="danger"
            closeButton
            :show.sync="loginError"
          >
           {{loginError}}
          </CAlert>
          <!--<p v-if="loginError">{{ loginError }}</p>-->
          <CCardGroup>
            <CCard class="p-4">
              <div v-if="loggingIn" class="container-loading">
                <img src="img/loading.gif" alt="Loading Icon">
              </div>
              <CCardBody>
                <CForm @submit.prevent="checkForm"
                      >
                  <div class="text-center">
                  <img
                      src="img/logo_black.png"
                  />
                  </div>
                  <h1>Login</h1>
                  <p class="text-muted">Ingresa con tu cuenta</p>
                  <CInput
                    placeholder="usuario"
                    autocomplete="usaurio"
                    v-model="usuario.userName"
                  >
                    <template #prepend-content><CIcon name="cil-user"/></template>
                  </CInput>
                  <CInput
                    placeholder="Password"
                    type="password"
                    autocomplete="curent-password"
                    v-model="usuario.password"
                  >
                    <template #prepend-content><CIcon name="cil-lock-locked"/></template>
                  </CInput>
                  <CRow>
                    <CCol col="6" class="text-left">
                      <CButton type="submit" color="primary" class="px-4">Login</CButton>
                    </CCol>
                    <CCol col="6" class="text-right">
                      <CButton color="link" class="px-0">Recuperar password?</CButton>
                      <CButton color="link" class="d-lg-none">Registrar Ahora!</CButton>
                     
                    </CCol>
                    <CCol>
                      
                    <p v-if="errors.length">
                      <b style="color:red"> Alerta</b>
                      <ul>
                        <li style="color:red;font-size:12px;"  v-for="(error, i) in errors" v-bind:key="i">{{ error }}</li>
                      </ul>
                    </p>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
            <CCard
              color="primary"
              text-color="white"
              class="text-center py-5 d-md-down-none"
              body-wrapper
            >
              <!--<CCardBody>
                <h2>Registro</h2>
                <p>Realiza tu registro con tu correo electrónico y una contraseña</p>
                <CButton
                  color="light"
                  variant="outline"
                  size="lg"
                  @click="register()"
                >
                  Registrar ahora!
                </CButton>
              </CCardBody>-->
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>    
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      errors: [],
      usuario: {
        userName: "",
        password: "",
      },
      resU:"",
      resP:"",
      expression: /^[A-Za-z0-9]+$/,
      idUsuario: this.$route.params.idUsuario,
      token: this.$route.params.token,
    };
  },
  methods: {

    async getParametros(){
      const payload = {
        metodo: "VALIDARTOKEN",
        data: {
          sValor1: this.idUsuario,
          sValor2: this.token,
        },
      };
      console.log(payload)
      
      const response = await this.$store.dispatch("metodoPost", payload);
      if (response) {
          const res = this.$store.getters.getRespuestaREST;
          this.resU = res[0].valorU
          this.resP = res[0].valorP
          console.log(this.resU)
          console.log(this.resP)
        }
    },
    async enterUserToken(){
      if(this.idUsuario != undefined && this.token != undefined){
          this.usuario.userName = atob(this.resU);
          this.usuario.password = atob(this.resP);
          this.login();
      }
    },
    async login(){
      if (!this.errors.length) {
        console.log(this.usuario)
          this.$store.dispatch("login", { usuario: this.usuario });
        } else {
          e.preventDefault();
          return true;
        }
    },
    checkForm: function (e) {
      this.errors = [];
      if (!this.usuario.userName) this.errors.push("Usuario requerido");
      if (!this.usuario.password) {
        this.errors.push("Password requerido");
      } else if (
        !this.expression.test(this.usuario.password) ||
        this.usuario.password.length < 3
      ) {
        this.errors.push("Password Invalido");
      }
      if(this.idUsuario == undefined && this.token == undefined){
        this.login();
      }
      
    },
  },
  computed: {
    ...mapState(["loggingIn", "loginError", "loginSuccessful"]),
  },
  mounted(){
    
    

    const promise = new Promise((resolve, _) => {
          resolve(this.getParametros());
        });
        promise.then(_ => {
          // setTimeout(() => {
            this.enterUserToken();
          // }, 1500)
        }
      );
  }
};
</script>
